import { render, staticRenderFns } from "./NomadPayerChat.vue?vue&type=template&id=dfa3c3ae"
import script from "./NomadPayerChat.vue?vue&type=script&lang=js"
export * from "./NomadPayerChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports